import { render, staticRenderFns } from "./CrewSignature.vue?vue&type=template&id=4af52022&"
import script from "./CrewSignature.vue?vue&type=script&lang=js&"
export * from "./CrewSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports